import { render, staticRenderFns } from "./PartnerReviewPage.vue?vue&type=template&id=ed91b8ec&scoped=true&"
import script from "./PartnerReviewPage.vue?vue&type=script&lang=js&"
export * from "./PartnerReviewPage.vue?vue&type=script&lang=js&"
import style0 from "./PartnerReviewPage.vue?vue&type=style&index=0&id=ed91b8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed91b8ec",
  null
  
)

export default component.exports